interface DesktopComputerIconProps {
  className?: string;
}

export default function DesktopComputerIcon({ className }: DesktopComputerIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      width="72"
      height="72"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="6" y="6" width="52" height="38" rx="3" fill="none" stroke="currentColor" strokeWidth="2.4" />
      <rect x="12" y="12" width="40" height="26" rx="1" fill="currentColor" opacity="0.12" />
      <path d="M32 44v7" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M18 51h28" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M12 57h40" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" />
    </svg>
  );
}
